export const vorschaedenPopoverContent = `Versicherte und unversicherte Schäden`;
